
<template>
  <div class="footer-value-props" :style="valuePropsStyles">
    <div class="footer-value-props-container container">
      <header class="text-center" v-if="schema.settings.sectionHeading">
        <h4 class="footer-value-prop-heading h4 color-black">{{ schema.settings.sectionHeading }}</h4>
      </header>
      <div class="footer-value-prop-slider">
        <template v-for="block in schema.blocks" >
          <div :key="block.id" class="footer-value-prop__icon-wrapper" v-if="block.settings.icon"><img class="footer-value-prop__icon" :src="block.settings.icon" :alt="block.iconAlt || block.settings.title"/></div>
          <div :key="block.id" class="footer-value-prop__text">
            <div class="footer-value-prop__title" style="text-transform:none;font-size:1.1rem;" v-if="block.settings.title">{{ block.settings.title }}</div>
          </div>
        </template>
      </div>
      <div class="text-center">
        <v-link class="footer-value-props-link" v-if="schema.settings.linkUrl && schema.settings.linkText" primary="primary" :href="schema.settings.linkUrl">{{ schema.settings.linkText }}</v-link>
      </div>
    </div>
  </div>
</template>

<script>
import VLink from '../buttons/VLink.vue'

export default {
  name: 'FooterValueProps',
  components: {
    VLink
  },
  props: {
    schema: Object
  },
  computed: {
    valuePropsStyles() {
      let styles = {
        backgroundColor: this.schema.settings.backgroundColor,
        color: this.schema.settings.textColor
      }
      if (this.schema.settings.backgroundImage) {
        styles.backgroundImage = `url(${this.$mq === 'mobile' && this.schema.settings.mobileBackgroundImage ? this.schema.settings.mobileBackgroundImage : this.schema.settings.backgroundImage })`;
      }
      return styles;
    }
  },
  methods: {}
}
</script>

<style scoped lang="scss">
  .footer-value-props {
    background-repeat: repeat;
    background-size: 350px 350px;
    background-position: center center;
  }
  .footer-value-props-container {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .footer-value-prop-slider {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 auto;
    align-items: center;

    @include desktop-up {
      flex-direction: row;
    }
  }

  .footer-value-prop-heading {
    margin-bottom: 8px;

    @include desktop-up {
      margin-bottom: 48px;
    }
  }

  .footer-value-props-link {
    margin-top: 20px;

    @include desktop-up {
      margin-top: 40px;
    }
  }

  .footer-value-prop {

    &__pagination {
      font-size: rem(8);
      line-height: 1;
      text-align: center;
      margin-top: 24px;

      @include desktop-up {
        display: none;
      }
    }

    &__content {
      display: flex;
      height: 100%;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      @include desktop-up {
        flex-direction: row;
      }
    }

    &__icon-wrapper {
      margin-bottom: 32px;
      flex: 1;
      @include desktop-up {
        flex: 1;
        text-align: center;
        margin-bottom: 0;
      }
    }

    &__icon {
      display: block;
      height: 18px;
      max-width: none;
      margin: 0 auto;
    }

    &__text {
      margin-bottom: 32px;

      &:last-child {
        margin-bottom: 0;
      }

      @include desktop-up {
        margin-bottom: 0;
        text-align: center;
        flex: 1;
      }
    }

    &__title {
      @include preheader();
      color: inherit !important;
      font-size: rem(12);
      line-height: rem(14);
      white-space: nowrap;

      @include desktop-up {
        font-size: rem(18);
        line-height: rem(17);
      }
    }

    /deep/ &__body {
      blockquote, dd, div, dl, dt, figcaption, figure, hr, li, main, ol, p, pre, ul, strong, a {
        color: inherit;
      }
    }
  }
</style>
